import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class ProductSimilarDiamond extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    const diamondData = [
      {
        image: '/img/productpage/diamond_main.png',
        description: 'Round 1.02 F SI1',
        price: 3402,
      },
      {
        image: '/img/productpage/diamond_main.png',
        description: 'Round 0.89 D IF',
        price: 2200,
      },
      {
        image: '/img/productpage/diamond_main.png',
        description: 'Round 1.48 E VS1',
        price: 8394,
      },
    ];

		this.state = {
      diamonds: diamondData,
    };
	}

	componentDidMount() {

  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className='ProductSimilarDiamond'>
			<div className='productSimilarTitle'>Similar Diamonds</div>
      <div className='productSimilarRefresh'>
        <img src='/img/productpage/refresh.svg' />
      </div>
      <div className='productSimilarWrapper'>
        {this.state.diamonds.map((diamond, i) => {
          return <div className='diamondItemWrapper' key={i}>
            <div className='diamondItemInnerWrapper'>
              <div className='diamondImageWrapper'>
                <img src={diamond.image} />
              </div>
              <div className='diamondInfoWrapper'>
                <div className='diamondTitleWrapper'><div>{diamond.description}</div></div>
                <div className='diamondPrice'>${diamond.price.toLocaleString()}</div>
              </div>
              <div className='diamondItemButtonWrapper'>
                <div className={'itemButton productSimilarButton'}>Change Diamond</div>
              </div>
            </div>
          </div>;
        })}
      </div>
		</div>;
	}
}
export default ProductSimilarDiamond;

function mapStateToProps(state) {
  return {

  };
}

export const ProductSimilarDiamondContainer = connect(
  mapStateToProps,
  allActionCreators
)(ProductSimilarDiamond);


// WEBPACK FOOTER //
// ./src/components/views/product-page/blocks/ProductSimilarDiamond.jsx